import styled from 'styled-components';

export const MainContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(262px, 1fr));
  grid-gap: 2rem;
  width: 100%;
`;
